<template>
  <div class="login">
    <!-- 背景装饰 -->
    <div class="login-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <!-- 中间主体 -->
    <div class="wrapper">
      <div class="container">
        <!-- 表单容器 -->
        <div class="login-form">
          <!-- 头部 -->
          <div class="form-header">
            <div class="logo-section">
              <div class="logo-icon">🔐</div>
              <div class="logo-text">
                <h2>欢迎登录</h2>
                <p>Welcome Back</p>
              </div>
            </div>
            <div class="header-decoration">
              <div class="decoration-line"></div>
              <div class="decoration-dot"></div>
              <div class="decoration-line"></div>
            </div>
          </div>

          <!-- 表单主体 -->
          <div class="form-body">
            <!-- 账号输入 -->
            <div class="input-group">
              <div class="input-container">
                <i class="iconfont icon-denglu2 input-icon"></i>
                <input 
                  type="text" 
                  placeholder="请输入账号" 
                  v-model="lUsername"
                  class="form-input"
                />
                <div class="input-focus-line"></div>
              </div>
            </div>

            <!-- 密码输入 -->
            <div class="input-group">
              <div class="input-container">
                <i class="iconfont icon-mima input-icon"></i>
                <input 
                  type="password" 
                  placeholder="请输入密码" 
                  v-model="lPassword"
                  class="form-input"
                />
                <div class="input-focus-line"></div>
              </div>
            </div>

            <!-- 登录按钮 -->
            <div class="btn-group">
              <button class="login-btn" @click="logo()">
                <span class="btn-text">登录</span>
                <div class="btn-icon">→</div>
                <div class="btn-shine"></div>
              </button>
            </div>

            <!-- 底部提示 -->
            <div class="form-footer">
              <div class="tips">
                <span class="tip-text">还没有账号？</span>
                <span class="reg-link" @click="goReg()">立即注册</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      href: "index.html",
      // 用户名
      lUsername: "",
      // 密码
      lPassword: "",
      // 获取收费跳转参数
      k: this.$route.query.k,
      // 获取到 user 用户信息
      logo_user: JSON.parse(window.localStorage.getItem("user")),
    };
  },
  mounted() {
    document.title = "京游科技（北京）有限公司";
  },
  methods: {
    // 登录逻辑
    logo() {
      if (this.k) {
        window.localStorage.setItem("state", "0");
        this.$router.push({ path: "/", query: { k: 1 } });
        window.location.reload();
      } else if (this.lUsername !== this.logo_user.Username) {
        alert("用户名错误");
      } else if (this.lPassword !== this.logo_user.Password) {
        alert("密码错误");
      } else {
        window.localStorage.setItem("state", "0");
        this.$router.push("/index");
        window.location.reload();
      }
    },
    goReg() {
      this.$router.push("/register");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import "./../assets/scss/button.scss";
@import "./../assets/font/iconfont.css";

.login {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  // 背景装饰
  .login-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    
    .bg-shape {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      
      &.shape-1 {
        width: 300px;
        height: 300px;
        top: -150px;
        right: -150px;
        animation: float 6s ease-in-out infinite;
      }
      
      &.shape-2 {
        width: 200px;
        height: 200px;
        bottom: -100px;
        left: -100px;
        animation: float 8s ease-in-out infinite reverse;
      }
      
      &.shape-3 {
        width: 150px;
        height: 150px;
        top: 50%;
        right: 20%;
        animation: float 5s ease-in-out infinite;
      }
    }
  }

  .wrapper {
    position: relative;
    z-index: 2;
    width: 100%;
    
    .container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      padding: 40px 20px;

      // 表单容器
      .login-form {
        width: 440px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        border-radius: 24px;
        padding: 50px 40px;
        box-shadow: 
          0 20px 60px rgba(0, 0, 0, 0.15),
          0 0 0 1px rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        animation: formSlideUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);

        // 头部
        .form-header {
          text-align: center;
          margin-bottom: 40px;
          
          .logo-section {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            margin-bottom: 20px;
            
            .logo-icon {
              font-size: 48px;
              background: linear-gradient(135deg, #1890ff, #52c41a);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
            }
            
            .logo-text {
              text-align: left;
              
              h2 {
                font-size: 28px;
                font-weight: 700;
                color: #1a1a1a;
                margin: 0 0 4px 0;
                line-height: 1.2;
              }
              
              p {
                font-size: 14px;
                color: #666;
                margin: 0;
                font-weight: 500;
              }
            }
          }
          
          .header-decoration {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            
            .decoration-line {
              width: 40px;
              height: 2px;
              background: linear-gradient(90deg, #1890ff, #52c41a);
              border-radius: 1px;
            }
            
            .decoration-dot {
              width: 6px;
              height: 6px;
              background: #1890ff;
              border-radius: 50%;
              animation: pulse 2s infinite;
            }
          }
        }

        // 表单主体
        .form-body {
          .input-group {
            margin-bottom: 24px;
            
            .input-container {
              position: relative;
              
              .input-icon {
                position: absolute;
                left: 16px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                color: #666;
                z-index: 2;
                transition: all 0.3s ease;
              }
              
              .form-input {
                width: 100%;
                height: 56px;
                padding: 0 20px 0 52px;
                border: 2px solid #f0f0f0;
                border-radius: 12px;
                font-size: 16px;
                background: #fff;
                transition: all 0.3s ease;
                outline: none;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                
                &:focus {
                  border-color: #1890ff;
                  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
                  
                  & + .input-focus-line {
                    width: 100%;
                  }
                  
                  & ~ .input-icon {
                    color: #1890ff;
                    transform: translateY(-50%) scale(1.1);
                  }
                }
                
                &::placeholder {
                  color: #999;
                }
              }
              
              .input-focus-line {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 2px;
                background: linear-gradient(90deg, #1890ff, #52c41a);
                transition: width 0.3s ease;
                border-radius: 1px;
              }
            }
          }

          // 登录按钮
          .btn-group {
            margin: 32px 0 24px;
            
            .login-btn {
              width: 100%;
              height: 56px;
              background: linear-gradient(135deg, #1890ff, #52c41a);
              border: none;
              border-radius: 12px;
              color: #fff;
              font-size: 16px;
              font-weight: 600;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              
              &:hover {
                transform: translateY(-2px);
                box-shadow: 
                  0 12px 30px rgba(24, 144, 255, 0.4),
                  0 4px 12px rgba(82, 196, 26, 0.3);
                
                .btn-icon {
                  transform: translateX(4px);
                }
                
                .btn-shine {
                  transform: translateX(100%);
                }
              }
              
              &:active {
                transform: translateY(0);
              }
              
              .btn-text {
                position: relative;
                z-index: 2;
              }
              
              .btn-icon {
                font-size: 18px;
                transition: transform 0.3s ease;
                position: relative;
                z-index: 2;
              }
              
              .btn-shine {
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                  90deg,
                  transparent,
                  rgba(255, 255, 255, 0.3),
                  transparent
                );
                transition: transform 0.6s ease;
              }
            }
          }

          // 底部提示
          .form-footer {
            text-align: center;
            
            .tips {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              
              .tip-text {
                font-size: 14px;
                color: #666;
              }
              
              .reg-link {
                font-size: 14px;
                color: #1890ff;
                font-weight: 600;
                cursor: pointer;
                position: relative;
                transition: all 0.3s ease;
                
                &:hover {
                  color: #52c41a;
                  
                  &::after {
                    width: 100%;
                  }
                }
                
                &::after {
                  content: '';
                  position: absolute;
                  bottom: -2px;
                  left: 0;
                  width: 0;
                  height: 2px;
                  background: linear-gradient(90deg, #1890ff, #52c41a);
                  transition: width 0.3s ease;
                  border-radius: 1px;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

@keyframes formSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 10px #1890ff;
  }
}

// 响应式调整
@media (max-width: 480px) {
  .login-form {
    width: 90% !important;
    padding: 40px 24px !important;
  }
}
</style>